// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.obfuscated-string{text-shadow:0 0 4px #333;color:rgba(0,0,0,0)}`, "",{"version":3,"sources":["webpack://./client/CommonComponents/HiddenString/HiddenString.scss"],"names":[],"mappings":"AAAA,mBACI,wBAAA,CACA,mBAAA","sourcesContent":[".obfuscated-string {\n    text-shadow: 0 0 4px #333;\n    color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
